export const SUPPORTED_LOCALES = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pt', 'ja'] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

const supportedLocaleSet = new Set<string>(SUPPORTED_LOCALES);

export function resolveBrowserLocale(input?: string): SupportedLocale {
  const normalized = input?.trim().toLowerCase();

  if (!normalized) {
    return 'en';
  }

  const [languageSubtag] = normalized.split('-');

  if (supportedLocaleSet.has(normalized)) {
    return normalized as SupportedLocale;
  }

  if (languageSubtag && supportedLocaleSet.has(languageSubtag)) {
    return languageSubtag as SupportedLocale;
  }

  return 'en';
}
